<template>
    <v-theme-provider>
      <base-section id="grouphead" space="10">
        <v-container>
          <v-row justify="center">
            <v-col cols="12">
              <base-section-heading title="Kepala Divisi" />
            </v-col>
            <v-col cols="12">
              <base-body space="0">
                <v-container fluid>
                  <v-row dense>
                    <v-col
                        v-for="(card, index) in filteredCards"
                        :key="card.name"
                        cols="12"
                        md="4"
                        >
                        <v-card class="card-img">
                            <v-card-title class="profile-name" style="display: flex; align-items: center; gap: 16px;">
                            <v-avatar size="80">
                                <v-img
                                contain
                                :src="
                                    card.thumbnail
                                    ? require(`@/assets/${card.thumbnail}`)
                                    : require('@/assets/user-no-photo.png')
                                "
                                :alt="card.thumbnail ? card.thumbnail : 'Placeholder Image'"
                                style="border: 1px solid #ccc;"
                                />
                            </v-avatar>
                            <span>{{ card.name }}</span>
                            </v-card-title>

                            <v-card-subtitle style="color: black; font-size: 13px;">
                            {{ card.title }}
                            </v-card-subtitle>

                            <v-expand-transition>
                            <div v-show="show[index]">
                                <v-divider></v-divider>
                                <v-card-text>{{ card.detail }}</v-card-text>
                            </div>
                            </v-expand-transition>
                        </v-card>
                    </v-col>
                  </v-row>
                  <v-dialog
                    v-model="dialog.detail"
                    max-width="90%"
                    persistent
                    style="border-radius: 20px"
                  >
                    <v-card>
                      <v-card-actions style="height: 80px">
                        <span class="primary--text">{{detail.title}}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          outlined
                          color="grey"
                          dark
                          @click="dialog.detail = false"
                          class="mr-5"
                        >
                          X
                        </v-btn>
                      </v-card-actions>
                      <v-divider></v-divider>
                      <v-progress-linear
                        indeterminate
                        v-if="loading.detail"
                      ></v-progress-linear>
                      <v-container>
                        <v-row class="mx-2">
                          <v-col cols="12" sm="3" class="text-center mb-4">
                            <v-avatar size="165">
                              <v-img
                                contain
                                :src="
                                  detail.img
                                    ? require(`@/assets/thumb-${detail.img}`)
                                    : require('@/assets/user-no-photo.png')
                                "
                                :alt="
                                  detail.img ? detail.img : 'Placeholder Image'
                                "
                                :style="{ border: '1px solid #ccc' }"
                              />
                            </v-avatar>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="9"
                            class="text-h4 display-flex justify-center align-center text-center-sm"
                            style="align-self: center; color: #114e87"
                          >
                            {{ detail.name }}
                          </v-col>
                          <v-col cols="12">
                            <div
                              class="display-flex text-justify"
                              v-html="detail.description"
                            ></div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-dialog>
                </v-container>
              </base-body>
            </v-col>
            <!-- <v-col cols="12">
              <base-section-heading title="Divisi" />
            </v-col>
            <v-col
            v-for="(division, i) in divisions"
            :key="i"
            cols="4"
            md="4"
          >
            <v-card
              color="secondary"
              class="mx-auto"
            >
              <v-card-item>
                <div>
                  <div class="text-overline mb-1 text-center white--text">
                    {{ division }}
                  </div>
                </div>
              </v-card-item>
  
              <v-card-actions>
                <v-btn>
                  Button
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col> -->
          </v-row>
        </v-container>
      </base-section>
    </v-theme-provider>
  </template>
  
  <script>
  //import Avatar from "../../components/base/Avatar.vue";
  export default {
    //components: { Avatar },
    name: "SectionGroupHead",
    data() {
      return {
        search: "", // Data untuk menyimpan nilai pencarian
        show: [], // array untuk menyimpan nilai show untuk setiap kartu
        detailShow: [],
        transition: [],
        dialog: {
          detail: false,
        },
        loading: {
          detail: false,
        },
        detail: {
          name: "",
          img: "",
          description: "",
        },
        cards: [
          {
            name: "Rinaldho Nurwansyah",
            title: "Kepala Divisi Bisnis",
            thumbnail: "thumb-rinaldho-nurwansyah.png",
          },
          {
            name: "Riva Ananta Baskara",
            title: "Kepala Divisi Operasional dan IT",
            thumbnail: "thumb-riva-ananta.png",
          },
          {
            name: "Hendika Anridia",
            title: "Kepala Divisi Unit Usaha Syariah",
            thumbnail: "thumb-hendika-anridia.png",
          },
        ],
        divisions: ['Audit & Compliance','Business','Operational','HC, GA & Corcom', 'Finance & Risk Management','Information Technology']
      };
    },
    computed: {
      // Filter kartu berdasarkan nilai pencarian
      filteredCards() {
        return this.cards.filter((card) => {
          // Memeriksa apakah nama atau detail kartu cocok dengan nilai pencarian
          return (
            card.name.toLowerCase().includes(this.search.toLowerCase()) ||
            card.detail.toLowerCase().includes(this.search.toLowerCase())
          );
        });
      },
    },
    methods: {
      toggleCard(index) {
        // Mengganti nilai show untuk kartu dengan indeks yang diberikan
        this.$set(this.show, index, !this.show[index]);
      },
      toggleDetail(index) {
        // Mengganti nilai show detail untuk kartu dengan indeks yang diberikan
        this.$set(this.detailShow, index, !this.detailShow[index]);
      },
      zoomIn(index) {
        // Mengubah nilai efek grayscale dan zoom saat hover
        this.$set(this.grayscale, index, "grayscale(0%)");
        this.$set(this.zoom, index, "scale(1.2)");
      },
      zoomOut(index) {
        // Mengubah nilai efek grayscale dan zoom saat hover
        this.$set(this.grayscale, index, "grayscale(100%)");
        this.$set(this.zoom, index, "scale(1)");
      },
      PersonDetail(image, name, desc, title) {
        this.dialog.detail = true;
        this.detail.img = image;
        this.detail.name = name;
        this.detail.description = desc;
        this.detail.title = title;
      },
    },
    created() {
      // Inisialisasi nilai show untuk setiap kartu menjadi false
      // this.cards.forEach(() => {
      //   this.show.push(false);
      //   this.detailShow.push(false);
      //   this.grayscale.push("grayscale(100%)");
      //   this.zoom.push("scale(1)");
      //   this.transition.push("0.3s ease-in-out;");
      // });
    },
  };
  </script>
  
  <style scoped>
  .image-container {
    filter: grayscale(100%);
  
    overflow: hidden;
    cursor: pointer;
    background-color: #fff;
    -webkit-box-shadow: -5px 7px 130px -20px rgba(0, 0, 0, 0.15);
    box-shadow: -5px 7px 130px -20px rgba(0, 0, 0, 0.15);
    height: 100%;
    position: relative;
  }
  .img-preview:hover {
    -webkit-transform: scale(1.5);
    transform: scale(1.2);
    transition: 0.3s ease-in-out;
    -webkit-transition: 0.3s ease-in-out;
  }
  .card-img {
    border-radius: 12px;
  }
  
  .profile-name {
    margin-bottom: 5px;
    font-family: "Reckless";
    font-size: 16px;
    font-weight: bold;
    line-height: 35px;
    color: #0c4f88;
  }
  .text-center-sm {
    @media (max-width: 600px) {
      text-align: center;
    }
  }
  </style>
  